import TagManager from "react-gtm-module";

function CompareSchoolsSquare({ ipeds }) {
  const tagManagerArgs = {
    dataLayer: {
      event: "interactionEvent",
      eventName: "compare_schools_square",
      ipeds: ipeds,
    },
  };

  TagManager.dataLayer(tagManagerArgs);
}

export default CompareSchoolsSquare;
